import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';

export default class ScheduledShopPause extends Model {
  [Type] = 'scheduled-shop-pause' as const;

  @attr('hoteldate') declare endDate: HoteldateTransformReturn;
  @attr('string') declare ota: string;
  @attr('hoteldate') declare startDate: HoteldateTransformReturn;
}
